module.exports = __webpack_public_path__ + "img/31.94291577.jpg";